import React, { useState } from 'react';
import Icon from '@sabre/spark-react-core/icon';
import TextInput from '@sabre/spark-react-core/text-input';
import { func, bool } from 'prop-types';
import { NOTIFICATION_MESSAGES } from '../../utils/notification-messages';

const DistributionNote = ({ onNoteSendClick, showWarning, disabled }) => {
   const [distributionNote, setDistributionNote] = useState('');
   const handleNoteTextChange = (updatedNote) =>
      setDistributionNote(updatedNote);
   const handleNoteSend = () => {
      if (distributionNote) onNoteSendClick(distributionNote);
      else if (!distributionNote)
         showWarning(NOTIFICATION_MESSAGES.EMPTY_DISTRIBUTION_NOTE);
   };
   return (
      <>
         <TextInput
            name='distribution-note-text'
            className='spark-pad-r-3'
            aria-label='distribution-note-text'
            value={distributionNote}
            disabled={disabled}
            multiLine={true}
            onChange={(event) => handleNoteTextChange(event.target.value)}
         >
            <Icon
               name='paper-airplane'
               data-testid='distribution-note-send-icon'
               size='md'
               style='fill'
               label='distribution-group-open'
               disabled={disabled}
               onClick={() => handleNoteSend(distributionNote)}
            />
         </TextInput>
         <div className='dg-log-note spark-bold'>
            <span
               className='spark-danger'
               data-testid='distribution-note-encryption'
            >
               {NOTIFICATION_MESSAGES.NO_ENCRYPTION_MESSAGE}
            </span>
            <span data-testid='distribution-note-ensure'>
               {NOTIFICATION_MESSAGES.ENSURE_NO_PERSONAL_DATA_MESSAGE}
            </span>
         </div>
      </>
   );
};
DistributionNote.propTypes = {
   onNoteSendClick: func,
   showWarning: func,
   disabled: bool,
};
export default DistributionNote;
